import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LayoutComponent } from 'app/shared/components/layout/layout.component';
import { UsersComponent } from 'app/account/components/users/users.component';
import { UserEditComponent } from 'app/account/components/user-edit/user-edit.component';
import { UserAddComponent } from 'app/account/components/user-add/user-add.component';
import { UnauthorizedComponent } from 'app/account/components/unauthorized/unauthorized.component';

export const ACCOUNT_ROUTES: Routes = [
    {
        path: 'account',
        component: LayoutComponent,
        canActivate: [MsalGuard],
        children: [
            { path: 'create', component: UserAddComponent },
            { path: 'create/:id', component: UserAddComponent },
            { path: 'users', component: UsersComponent },
            { path: 'user/:id', component: UserEditComponent },
            { path: 'unauthorized', component: UnauthorizedComponent }
        ]
    }
];
